import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaBuilding, FaDraftingCompass, FaMap, FaFileSignature } from "react-icons/fa";
import Reveal from "../ui/Reveal";
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

const services = [
    {
        slug: "declaratoria-fabrica",
        icon: <FaFileSignature />,
        title: "Declaratoria de Fábrica",
        description: "Regulariza tu construcción ante registros públicos."
    },
    {
        slug: "prescripcion-adquisitiva",
        icon: <FaBuilding />,
        title: "Prescripción Adquisitiva",
        description: "Obtén la propiedad legal de un inmueble por posesión."
    },
    {
        slug: "subdivision-lotes",
        icon: <FaMap />,
        title: "Subdivisión de Lotes",
        description: "Divide tu terreno cumpliendo normativa urbana."
    },
    {
        slug: "independizacion-viviendas",
        icon: <FaBuilding />,
        title: "Independización de Viviendas",
        description: "Separa legalmente unidades inmobiliarias."
    },
    {
        slug: "levantamiento-topografico",
        icon: <FaDraftingCompass />,
        title: "Levantamiento Topográfico",
        description: "Medición precisa del terreno con equipos especializados."
    },
    {
        slug: "planos-edificacion",
        icon: <FaDraftingCompass />,
        title: "Planos de Edificación",
        description: "Diseño técnico profesional para tu vivienda."
    }
];

const ServicesPreview = () => {
    return (
        <section className="py-24 md:py-24 bg-white" id="regularizacion">
            <div className="max-w-7xl mx-auto px-6">

                <Reveal>
                    <div className="text-center mb-12 md:mb-16">
                        <h2 className="text-3xl md:text-5xl font-black text-[#1C1C1C] tracking-tight">
                            Regularización de <span className="text-[#F26B1D]">Predios</span>
                        </h2>
                        <div className="w-16 h-1 bg-[#F26B1D] mx-auto mt-4 rounded-full" />
                        <p className="text-gray-500 mt-6 max-w-2xl mx-auto text-base md:text-lg font-medium">
                            Soluciones técnicas y legales para formalizar y potenciar tu propiedad.
                        </p>
                    </div>
                </Reveal>

                {/* VERSIÓN MÓVIL: Swiper Carrusel - CORREGIDA */}
                <div className="md:hidden w-full overflow-hidden"> {/* <--- Contenedor padre bloquea el desborde */}
                    <Swiper
                        modules={[Pagination, Autoplay]}
                        spaceBetween={16}
                        slidesPerView={1.15} // Reducimos ligeramente para evitar que el slide lateral "empuje" el layout
                        centeredSlides={true}
                        loop={true} // El loop ayuda a que no se vea espacio vacío al final
                        pagination={{
                            clickable: true,
                            dynamicBullets: true
                        }}
                        autoplay={{ delay: 3000 }}
                        className="pb-16 px-4 !overflow-visible" // Solo el Swiper puede desbordar internamente
                    >
                        {services.map((service, index) => (
                            <SwiperSlide key={index} className="h-auto">
                                <Link to={`/servicios/${service.slug}`} className="block h-full py-4"> {/* Padding aquí para las sombras */}
                                    <div className="p-7 rounded-3xl border border-gray-100 shadow-xl shadow-gray-200/50 bg-white h-[280px] flex flex-col justify-center transition-all active:scale-95 duration-300">
                                        <div className="text-[#F26B1D] text-3xl mb-4 bg-[#F26B1D]/5 w-12 h-12 flex items-center justify-center rounded-2xl">
                                            {service.icon}
                                        </div>
                                        <h3 className="text-lg font-bold text-[#1C1C1C] mb-2 leading-tight">
                                            {service.title}
                                        </h3>
                                        <p className="text-gray-500 text-sm line-clamp-3 leading-relaxed">
                                            {service.description}
                                        </p>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                {/* VERSIÓN DESKTOP: Grid Original */}
                <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-8">
                    {services.map((service, index) => (
                        <Link key={index} to={`/servicios/${service.slug}`} className="group">
                            <motion.div
                                whileHover={{ y: -8 }}
                                className="p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl hover:border-[#F26B1D]/20 transition-all duration-300 bg-white h-full"
                            >
                                <div className="text-[#F26B1D] text-3xl mb-5 bg-[#F26B1D]/5 w-14 h-14 flex items-center justify-center rounded-xl group-hover:bg-[#F26B1D] group-hover:text-white transition-all">
                                    {service.icon}
                                </div>
                                <h3 className="text-xl font-bold text-[#1C1C1C] mb-3">{service.title}</h3>
                                <p className="text-gray-600 leading-relaxed">{service.description}</p>
                            </motion.div>
                        </Link>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <Link
                        to="/servicios"
                        className="inline-block w-full sm:w-auto bg-[#1C1C1C] text-white px-10 py-4 rounded-2xl font-bold hover:bg-[#F26B1D] transition-all shadow-lg"
                    >
                        Ver todos los servicios
                    </Link>
                </div>
            </div>

            {/* Ajuste para los puntitos de la paginación de Swiper */}
            <style stroke="true">{`
                .swiper-pagination-bullet-active {
                    background: #F26B1D !important;
                }
            `}</style>
        </section>
    );
};

export default ServicesPreview;